import React from 'react';
import { Form } from 'react-bootstrap';

function CheckboxSection({
    sectionName,
    label,
    selectedChapters,
    setSelectedChapters,
    expandedSections,
    toggleSection,
    toggleAllChildCheckboxes,
    handleChildCheckboxChange,
    arrowUpIcon,
    arrowDownIcon,
    childCheckboxes,
}) {
    return (
        <div className="checkbox-content" controlId={`form${sectionName}Section`}>
            <div className="checkbox-list-header">
                <Form.Check
                    className={`${selectedChapters[sectionName] ? 'active' : ''}`}
                    id={`${sectionName}-checkbox`}
                    type="checkbox"
                    label={label}
                    checked={selectedChapters[sectionName]}
                    onChange={(e) => {
                        const isChecked = e.target.checked;
                        setSelectedChapters((prev) => ({
                            ...prev,
                            [sectionName]: isChecked,
                        }));
                        toggleAllChildCheckboxes(sectionName, isChecked);
                    }}
                />
                <span className="checkbox-arrow" onClick={() => toggleSection(sectionName)}>
                    {expandedSections[sectionName] ? arrowUpIcon : arrowDownIcon}
                </span>
            </div>
            {expandedSections[sectionName] && (
                <div className={`checkbox-list-body ${expandedSections[sectionName] ? "active" : ""}`}>
                    {childCheckboxes.map((child) => (
                        <Form.Check
                            className={`${selectedChapters[child.name] ? 'active' : ''}`}
                            key={child.name}
                            type="checkbox"
                            id={`${sectionName}-${child.name}-checkbox`}
                            label={child.label}
                            checked={selectedChapters[child.name]}
                            onChange={() => handleChildCheckboxChange(child.name)}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default CheckboxSection;
